const React = require("react");
const PropTypes = require("prop-types");
const classNames = require("classnames");

const Pill = ({ children, variant }) => {
  const classes = classNames("pill", {
    "pill--active": variant === "active",
    "pill--inactive": variant === "inactive",
  });
  return <div className={classes}>{children}</div>;
};

Pill.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["active", "inactive", "none"]),
};

Pill.defaultProps = {
  variant: "none",
};

module.exports = Pill;
